import DokumenService from "../../services/datamaster/dokumen.service";

export const MasterDokumen = {
  data() {
    return {
      loadingMultiSelect : {
        isLoadingDokumen : true,
      },
      loading: true,
      optionMasterDokumen : [],
      optionMasterDokumenForDokumenPendukung : [],
      optionMasterDokumenForDokumenRekomendasi : [],
      optionMasterDokumenForDokumenAnggotaUmum : [],
      optionMasterDokumenForDokumenAseanCpa : [],
      multi_master_dokumen : [],
      modelMasterDokumen : '',
      items_master_dokumen : [],
    };
  },
  methods: {
    getAllDokumen() {
      this.loading = true;
        DokumenService.getDokumen(0,1000,"default")
        .then(response => {
            this.optionMasterDokumen = response.data.data.content
            this.items_master_dokumen = response.data.data.content 
            this.loadingMultiSelect.isLoadingDokumen = false
            this.loading = false
        }).catch(error => {
            // comment console console.log(error)
            this.loading = false
        })
    },
    getAllDokumenForDokumenPendukung() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenService.getAllDokumenForDokumenPendukung()
      .then(response => {
          this.optionMasterDokumenForDokumenPendukung = response.data.data
          loader.hide()
      }).catch(error => {
          // comment console console.log(error)
      })
    },

    getAllDokumenForDokumenRekomendasi(id_rekomendasi) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenService.getAllDokumenForDokumenRekomendasi(id_rekomendasi)
      .then(response => {
          this.optionMasterDokumenForDokumenRekomendasi = response.data.data
          loader.hide()
      }).catch(error => {
          // comment console console.log(error)
      })
    },

    getAllDokumenForDokumenAseanCpa() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenService.getAllDokumenForDokumenAseanCpa()
      .then(response => {
          this.optionMasterDokumenForDokumenAseanCpa = response.data.data
          loader.hide()
      }).catch(error => {
          // comment console console.log(error)
      })
    },

    getAllDokumenForDokumenAnggotaUmum() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DokumenService.getAllDokumenForDokumenAnggotaUmum()
      .then(response => {
          this.optionMasterDokumenForDokumenAnggotaUmum = response.data.data
          loader.hide()
      }).catch(error => {
          // comment console console.log(error)
      })
    }
  }
};